module.exports = __webpack_public_path__ + "static/media/افضل سكن في انترلاكن للعائلات.55e659b5.jpg";